(function () {
  if (window.clShippingCopyInitialized) return;
  window.clShippingCopyInitialized = true;

  const selector = '._rsi-build-block-custom-text';
  const oldShippingAmount = /\b2[.,\s]?500(?=\s*(?:TL|₺)?\s*(?:üzeri|\+)?\s*ücretsiz\s*kargo)/gi;

  function updateBlock(block) {
    const walker = document.createTreeWalker(block, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.parentElement.closest('script, style, textarea, input')
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT;
      }
    });
    let node;
    while ((node = walker.nextNode())) {
      const updated = node.nodeValue.replace(oldShippingAmount, '3000');
      if (updated !== node.nodeValue) node.nodeValue = updated;
    }
  }

  function collectBlocks(node, blocks) {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element) return;
    const block = element.closest(selector);
    if (block) blocks.add(block);
    element.querySelectorAll(selector).forEach(block => blocks.add(block));
  }

  document.querySelectorAll(selector).forEach(updateBlock);
  const observer = new MutationObserver(records => {
    const blocks = new Set();
    records.forEach(record => {
      if (record.type === 'characterData') collectBlocks(record.target, blocks);
      record.addedNodes.forEach(node => collectBlocks(node, blocks));
    });
    blocks.forEach(updateBlock);
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
